<template>
  <div>
    <header>
      <!-- Custom CSS -->
      <link rel="stylesheet" href="../../../public/portal-api/css/style.css">
      <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css"
        integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
    </header>

    <section class="banner">
      <div class="subtitle-container mt-5 ml-5">
        <h3 class="title mb-5" style="top: -3px; position: relative; text-align: center;">
          <span>BEM VINDO(A) AO</span></br>PORTAL DE INTEGRAÇÕES & API
        </h3>
      </div>
    </section>

    <section class="cards">
      <div class="container">
        <div class="row g-1 d-flex justify-content-between">


          <div style="height: 350px;width: 360px !important;" class="card d-flex justify-content-center">
            <div class="card-body">
              <h5 class="card-completed-title">INTEGRAÇÕES CONCLUÍDAS</h5>

              <div class="linha"></div>

              <div class="father-div-progress mt-4">
                <div model="selectedListaConcluidas" v-for="concluida in this.listaConcluidas"
                  :key="concluida.codigoProduto" :value="concluida.codigo">
                  <!-- Card interno -->
                  <div>
                    <div class="card-intern">
                      <div class="card-icons">
                        <div class="">

                          <i class="icon-line" v-if="concluida != undefined && iconFor(concluida)">
                            <img class="card-img" :class="safeIcon(concluida).customClass || ''"
                              :src="`/massificados/corporativo/gerenciador-parceiros-ui/${iconFor(concluida).path || 'consulta'}/img/${iconFor(concluida).img}`">
                            <p class="card-text mt-1 card-img-text">
                              {{ iconFor(concluida).label }}
                            </p>
                          </i>

                          <!-- 
                        <i v-if="concluida.codigoProduto === 7" class="icon-line">
                          <img class="card-img" src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_carro.svg">
                          <p class="card-text mt-1 card-img-text"><small>AUTOMÓVEL</small></p>
                        </i>
                        <i v-if="concluida.codigoProduto === 14" class="icon-line">
                          <img class="card-img" src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_residencial.svg">
                          <p class="card-text mt-1 card-img-text"><small>RESIDENCIAL</small></p>
                        </i>
                        <i v-if="concluida.codigoProduto === 43 || concluida.codigoProduto === 44" class="icon-line">
                          <img class="card-img" src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_imobiliario.svg">
                          <p class="card-text mt-1 card-img-text"><small>IMOBILIÁRIO</small></p>
                        </i>
                        <i v-if="concluida.codigoProduto === 12" class="icon-line">
                          <img class="card-img" src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_condominio.svg">
                          <p class="card-text mt-1 card-img-text"><small>CONDOMÍNIO</small></p>
                        </i>
                        <i v-if="concluida.codigoProduto === 47" class="icon-line">
                          <img class="card-img" src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_vida.svg">
                          <p class="card-text mt-1 card-img-text"><small>VIDA</small></p>
                        </i>
                        <i v-if="concluida.codigoProduto === 55 || concluida.codigoProduto === 56  || concluida.codigoProduto === 72  || concluida.codigoProduto === 73" class="icon-line">
                          <img class="card-img" src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_aluguel.svg">
                          <p class="card-text mt-1 card-img-text"><small>ALUGUEL</small></p>
                        </i>
                        <i v-if="concluida.codigoProduto === 7503 || concluida.codigoProduto === 7602 || concluida.codigoProduto === 7603 || (concluida.produto != undefined && concluida.produto.toUpperCase().includes('GARANTIA'))" class="icon-line">
                          <img class="card-img" src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_garantia.svg">
                          <p class="card-text mt-1 card-img-text"><small>GARANTIA</small></p>
                        </i>
                        <i v-if="concluida.codigoProduto === 62 || concluida.codigoProduto === 63 || (concluida.produto != undefined &&concluida.produto.toUpperCase().includes('EMPRESARIAL'))" class="icon-line">
                          <img class="card-img" src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_empresarial.svg">
                          <p class="card-text mt-1 card-img-text"><small>EMPRESARIAL</small></p>
                        </i>
                        <i v-if="concluida.codigoProduto === 103 || concluida.produto.toUpperCase().includes('AGRO SAFRA')" class="icon-line">
                          <img class="card-img" src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_agro.svg">
                          <p class="card-text mt-1 card-img-text-safra"><small>AGRO SAFRA</small></p>
                        </i>
                        <i v-if="concluida.codigoProduto === 10005 || concluida.codigoProduto === 10006 || concluida.codigoProduto === 10017 || (concluida.produto != undefined && concluida.produto.toUpperCase().includes('EQUIPAMENTOS'))" class="icon-line">
                          <img class="card-img" src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_equipamentos.svg">
                          <p class="card-text mt-1 card-img-text"><small>EQUIPAMENTOS</small></p>
                        </i>
                        <i v-if="concluida.codigoProduto === 108 || (concluida.produto != undefined && concluida.produto.toUpperCase().includes('VIAGEM'))" class="icon-line">
                          <img class="card-img" src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_viagem.svg">
                          <p class="card-text mt-1 card-img-text"><small>VIAGEM</small></p>
                        </i> -->
                        </div>
                      </div>

                      <div class="card-info">
                        <!-- <div  class="card-body"> -->
                        <h5 class="card-text">CORRETORES <br> INTEGRADOS:</h5>
                        <h5 class="card-text">
                          <span class="card-text">{{ concluida.qtd_corretor }}</span>
                        </h5>
                        <!-- </div> -->
                      </div>
                    </div>
                  </div>

                </div>
                <div v-if="listaConcluidas.length == 0" class="msg-integracoes">A sua operadora não possui nenhuma integração concluída!</div>
              </div>
            </div>
          </div>

          <div style="height: 350px;width: 360px !important;" class="card d-flex justify-content-center">
            <div class="card-body">
              <h5 class="card-progress-title">INTEGRAÇÕES EM ANDAMENTO</h5>

              <div class="linha"></div>

              <div class="father-div-progress mt-4">
                <div model="selectedListaConcluidas" v-for="itemEmAndamento in this.listaEmAndamento"
                  :key="itemEmAndamento.id" :value="itemEmAndamento.codigoOperadora">
                  <!-- Card interno -->
                  <div>
                    <div class="card-intern">
                      <div class="card-icons">
                        <div class="">
                          <!-- <i class="icon-line" v-for="icon in iconMap" :key="icon.key" v-if="itemEmAndamento.api != undefined && itemEmAndamento.api.toUpperCase().includes(icon.key)" >
                          <img class="card-img" 
                            :class="safeIcon(itemEmAndamento).customClass || ''"
                            :src="`/massificados/corporativo/gerenciador-parceiros-ui/${icon.path || 'consulta'}/img/${icon.img}`">
                          <p class="card-text mt-1 card-img-text">
                            <small>{{ icon.label }}</small>
                          </p>
                        </i> -->

                          <i class="icon-line" v-for="icon in iconsForApi(itemEmAndamento)" :key="icon.key">
                            <img class="card-img" :class="icon.customClass || ''"
                              :src="`/massificados/corporativo/gerenciador-parceiros-ui/${icon.path || 'consulta'}/img/${icon.img}`">
                            <p class="card-text mt-1 card-img-text">{{ icon.label }}</p>
                          </i>

                        </div>
                      </div>

                      <div class="card-info">

                        <h5 class="card-text" style="height: 7% !important;">
                          DATA:
                          <span class="card-text card-subtext">{{ formatarData(itemEmAndamento.dataCriacao) }}</span>
                        </h5>
                        <h5 v-for="situacao in situacaoMap" :key="situacao.key"
                          v-if="itemEmAndamento.situacao === situacao.key" class="card-text mt-2"
                          :style="situacao.style">
                          SITUAÇÃO:
                          <span class="card-text card-subtext" style="margin-top: 10% !important;">
                            {{ situacao.label }}
                          </span>
                        </h5>

                        <!-- <div style="margin-left: 1%;margin-top: -10px !important" class="card-body justify-content-center"> -->


                        <!-- <h5 class="card-text mt-2" style="height: 7% !important;">DATA:
                          <span class="card-text card-subtext">{{ formatarData(itemEmAndamento.dataCriacao) }}</span>
                        </h5>
                        <h5 v-if="itemEmAndamento.situacao === 'APROVACAO-PRODUTOS'" class="card-text mt-2"
                          style="margin-top: 10% !important;font-size: 10px; margin-left: -0px;width:140% !important">
                          SITUAÇÃO:
                          <span class="card-text card-subtext"
                            style="margin-top: 10% !important;font-size: 10px !important;">APROVAÇÃO</span>
                        </h5>
                        <h5 v-if="itemEmAndamento.situacao === 'CONFIGURACAO-ACEITE'" class="card-text mt-2"
                          style="margin-top: 10% !important;font-size: 10px; margin-left: -45px;width:150% !important">
                          SITUAÇÃO:
                          <span class="card-text card-subtext"
                            style="margin-top: 10% !important;font-size: 10px !important;">CONFIGURAÇÃO ACEITE</span>
                        </h5>
                        <h5 v-if="itemEmAndamento.situacao === 'DESENVOLVINENTO'" class="card-text mt-2"
                          style="margin-top: 10% !important;font-size: 10px; margin-left: -45px;width:150% !important">
                          SITUAÇÃO:
                          <span class="card-text card-subtext"
                            style="margin-top: 10% !important;font-size: 10px !important;">DESENVOLVINENTO</span>
                        </h5>
                        <h5
                          v-if="itemEmAndamento.situacao === 'HOMOLOGACAO-TI' || itemEmAndamento.situacao === 'HOMOLOGACAO-PRODUTOS'"
                          class="card-text mt-2"
                          style="margin-top: 10% !important;font-size: 10px; margin-left: -45px;width:150% !important">
                          SITUAÇÃO:
                          <span class="card-text card-subtext"
                            style="margin-top: 10% !important;font-size: 10px !important;">HOMOLOGAÇÃO</span>
                        </h5>
                        <h5 v-if="itemEmAndamento.situacao === 'CONFIGURACAO-PRODUCAO'" class="card-text mt-2"
                          style="margin-top: 10% !important;font-size: 10px; margin-left: -19px;width:150% !important">
                          SITUAÇÃO:
                          <span class="card-text card-subtext"
                            style="margin-top: 10% !important;font-size: 10px !important;">CONFIG. PRODUÇÃO</span>
                        </h5> 
                      </div>-->
                      </div>

                    </div>
                  </div>
                </div>
                <div v-if="listaEmAndamento.length == 0" class="msg-integracoes">A sua operadora não possui nenhuma integração em andamento!</div>
              </div>

            </div>
          </div>

          <div class="card d-flex justify-content-center" style="height: 350px;width: 360px !important;">
            <div class="card-body body-alert d-flex flex-column">
              <h5 class="card-progress-title text-center alert-title">ALERTAS / NOTIFICAÇÕES</h5>
              <div class="linha" style="width: 44%;  height: 2px !important; margin-top:1px; margin-bottom: 20px"></div>

              <div class="father-div-progress">
                <div model="selectedListaNotificacao" v-for="itemNotificacao in this.listaNotificacao"
                  :key="itemNotificacao.id" :value="itemNotificacao.titulo">
                  <div class="alert-list">
                    <!-- Alerta 1 -->
                    <div v-if="itemNotificacao.visto === 'N'" class="alert-item d-flex align-items-center text-center">
                      <i style="padding-left: 6px !important;" class="fas fa-exclamation warning-icon mt-1"></i>
                      <a href="javascript:void(0)" @click="openModal(itemNotificacao)">
                        <span style="padding-left:3px !important;" class="alert-text"><strong>{{ itemNotificacao.titulo
                        }}</strong></span>
                      </a>
                    </div>

                    <!-- Alerta 2 -->
                    <div v-if="itemNotificacao.visto === 'S'" class="alert-item text-center">
                      <a href="javascript:void(0)" @click="openModal(itemNotificacao)">
                        <span class="alert-text">{{ itemNotificacao.titulo }}</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>

    <div id="carouselExampleControls" class="carousel slide" data-ride="false">
      <div class="carousel-inner">
        <div class="carousel-item active">
          <section>
            <div class="subtitle-container mt-4 ml-2">
              <h3 class="title" style="color: #19987C">CATÁLOGO DE API - VENDAS</h3>
            </div>
            <div class="linha-api"></div>
          </section>

          <div class="row mt-5 main-div" style="margin-left: 16% !important">
            <!-- Card 1 -->
            <div class="col-2">
              <div class="card mt-2 pt-3 pb-3"
                style="margin-bottom:200px; padding-bottom: 7.5% !important; width: 88% !important; height: 7.2rem !important; background: linear-gradient(203deg, #B9B970 17%, #019074);margin-left: 0px">
                <img class="icon-line"
                  style="color: white !important; filter: brightness(0) invert(1); width: 80px; height: 2.9rem; display: block; margin: 20px auto;"
                  src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_carro.svg"
                  alt="Imagem de capa do card">
                <div class="card-footer mt-2 pb-4 pt-4">
                  <span class="card-text">AUTOMÓVEL</span>
                  <!-- <button type="button" class="btn btn-secondary btd"
                    @click="acessarDocumentacao('API de Venda Automóvel')" data-doc="auto" data-mdb-toggle="tooltip"
                    title="Download">
                    <i class="fa-solid fa-download"></i>
                  </button> -->
                </div>
                <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="prev"
                  style="margin-top:138px !important">
                  <i class="fas fa-angle-left"
                    style="color: #0B9274; font-size: 28px; margin-left:-395px; margin-top:-20px"></i>
                </a>
              </div>
            </div>

            <!-- Card 2 -->
            <div class="col-2">
              <div class="card mt-2 pt-2 pb-3"
                style="margin-bottom:200px; padding-bottom: 7.5% !important; width: 88% !important; height: 7rem !important; background: linear-gradient(203deg, #B9B970 17%, #019074);margin-left: -30px">
                <img class="icon-line"
                  style="color: white !important; filter: brightness(0) invert(1); width: 100px; height: 3.3rem; display: block; margin: 20px auto;"
                  src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_residencial.svg"
                  alt="Imagem de capa do card">
                <div class="card-footer mt-2 pb-4 pt-4">
                  <span class="card-text">RESIDENCIAL</span>
                  <!-- <button type="button" class="btn btn-secondary btd" @click="openDoc('residencial')" data-doc="auto"
                    data-mdb-toggle="tooltip" title="Download">
                    <i class="fa-solid fa-download"></i>
                  </button> -->
                </div>
              </div>
            </div>

            <!-- Card 3 -->
            <div class="col-2">
              <div class="card mt-2 pt-2 pb-3"
                style="margin-bottom:200px; padding-bottom: 7.5% !important; width: 88% !important; height: 7.2rem !important; background: linear-gradient(203deg, #B9B970 17%, #019074);margin-left: -60px">
                <img class="icon-line"
                  style="color: white !important; filter: brightness(0) invert(1); width: 100px; height: 3.5rem; display: block; margin: 20px auto;"
                  src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_imobiliario.svg"
                  alt="Imagem de capa do card">
                <div class="card-footer mt-2 pb-4 pt-4">
                  <span class="card-text">IMOBILIÁRIO</span>
                  <!-- <button type="button" class="btn btn-secondary btd" @click="openDoc('imobiliario')" data-doc="auto"
                    data-mdb-toggle="tooltip" title="Download">
                    <i class="fa-solid fa-download"></i>
                  </button> -->
                </div>
              </div>
            </div>

            <!-- Card 4 -->
            <div class="col-2">
              <div class="card mt-2 pt-3 pb-3"
                style="margin-bottom:200px; padding-bottom: 7.5% !important; width: 88% !important; height: 7.2rem !important; background: linear-gradient(203deg, #B9B970 17%, #019074);margin-left: -90px">
                <img class="icon-line"
                  style="color: white !important; filter: brightness(0) invert(1); width: 100px; height: 3.0rem; display: block; margin: 20px auto;"
                  src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_condominio.svg"
                  alt="Imagem de capa do card">
                <div class="card-footer mt-2 pb-4 pt-4">
                  <span class="card-text">CONDOMÍNIO</span>
                  <!-- <button type="button" class="btn btn-secondary btd" @click="openDoc('condominio')" data-doc="auto"
                    data-mdb-toggle="tooltip" title="Download">
                    <i class="fa-solid fa-download"></i>
                  </button> -->
                </div>
              </div>
            </div>

            <!-- Card 4 -->
            <div class="col-2">
              <div class="card mt-2 pt-2 pb-3"
                style="margin-bottom:200px; padding-bottom: 7.5% !important; width: 88% !important; height: 7.1rem !important; background: linear-gradient(203deg, #B9B970 17%, #019074);margin-left: -120px">
                <img class="icon-line"
                  style="color: white !important; filter: brightness(0) invert(1); width: 100px; height: 3.4rem; display: block; margin: 20px auto;"
                  src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_vida.svg"
                  alt="Imagem de capa do card">
                <div class="card-footer mt-2 pb-4 pt-4">
                  <span class="card-text" style="padding-right: 24px; padding-left: 22px;">VIDA</span>
                  <!-- <button type="button" class="btn btn-secondary btd" @click="openDoc('vida')" data-doc="auto"
                    data-mdb-toggle="tooltip" title="Download">
                    <i class="fa-solid fa-download"></i>
                  </button> -->
                </div>
                <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next"
                  style="margin-top:135px !important">
                  <i class="fas fa-angle-right"
                    style="color: #0B9274; font-size: 28px; margin-left: 100px; margin-top:-30px"></i>
                </a>
              </div>
            </div>
          </div>

          <div class="row sub-div" style="margin-left:10% !important;">
            <!-- Card 1 -->
            <div class="col-2">
              <div class="card mt-2 pt-2 pb-3"
                style="margin-bottom:200px; padding-bottom: 7.5% !important; width: 88% !important; height: 7.1rem !important; background: linear-gradient(203deg, #B9B970 17%, #019074);margin-left: 90px">
                <img class="icon-line"
                  style="color: white !important; filter: brightness(0) invert(1); width: 100px; height: 3.4rem; display: block; margin: 20px auto;"
                  src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_aluguel.svg"
                  alt="Imagem de capa do card">
                <div class="card-footer mt-2 pb-4 pt-4">
                  <span class="card-text" style="padding-right: 10px; padding-left: 8px;">ALUGUEL</span>
                  <!-- <button type="button" class="btn btn-secondary btd" @click="openDoc('aluguel')" data-doc="auto"
                    data-mdb-toggle="tooltip" title="Download">
                    <i class="fa-solid fa-download"></i>
                  </button> -->
                </div>
              </div>
            </div>

            <!-- Card 2 -->
            <div class="col-2">
              <div class="card mt-2 pt-2 pb-3"
                style="margin-bottom:200px; padding-bottom: 7.5% !important; width: 88% !important; height: 7.1rem !important; background: linear-gradient(203deg, #B9B970 17%, #019074);margin-left: 60px">
                <img class="icon-line"
                  style="color: white !important; filter: brightness(0) invert(1); width: 100px; height: 3.4rem; display: block; margin: 20px auto;"
                  src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_garantia.svg"
                  alt="Imagem de capa do card">
                <div class="card-footer mt-2 pb-4 pt-4">
                  <span class="card-text" style="padding-right: 10px; padding-left: 8px;">GARANTIA</span>
                  <!-- <button type="button" class="btn btn-secondary btd" @click="openDoc('garantia')" data-doc="auto"
                    data-mdb-toggle="tooltip" title="Download">
                    <i class="fa-solid fa-download"></i>
                  </button> -->
                </div>
              </div>
            </div>

            <!-- Card 3 -->
            <div class="col-2">
              <div class="card mt-2 pt-2 pb-3"
                style="margin-bottom:200px; padding-bottom: 7.5% !important; width: 88% !important; height: 7.1rem !important; background: linear-gradient(203deg, #B9B970 17%, #019074);margin-left: 30px">
                <img class="icon-line"
                  style="color: white !important; filter: brightness(0) invert(1); width: 100px; height: 3.4rem; display: block; margin: 20px auto;"
                  src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_empresarial.svg"
                  alt="Imagem de capa do card">
                <div class="card-footer mt-2 pb-4 pt-4">
                  <span class="card-text">EMPRESARIAL</span>
                  <!-- <button type="button" class="btn btn-secondary btd" @click="openDoc('empresarial')" data-doc="auto"
                    data-mdb-toggle="tooltip" title="Download">
                    <i class="fa-solid fa-download"></i>
                  </button> -->
                </div>
              </div>
            </div>

            <!-- Card 4 
            <div class="col-2">
              <div class="card mt-2 pt-2 pb-3" style="margin-bottom:200px; padding-bottom: 7.5% !important; width: 88% !important; height: 7.1rem !important; background: linear-gradient(203deg, #B9B970 17%, #019074);margin-left: -60px">
                <img class="icon-line" style="color: white !important; filter: brightness(0) invert(1); width: 100px; height: 3.4rem; display: block; margin: 20px auto;" src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_agro.svg" alt="Imagem de capa do card">
                <div class="card-footer mt-2 pb-4 pt-4">
                  <span class="card-text">AGRO SAFRA</span>
                  <button type="button" class="btn btn-secondary btd" @click="openDoc('agro')" data-doc="auto" data-mdb-toggle="tooltip" title="Download">
                    <i class="fa-solid fa-download"></i>
                  </button>
                </div>
              </div>
            </div>
            -->

            <!-- Card 4 -->
            <div class="col-2">
              <div class="card mt-2 pt-2 pb-3"
                style="margin-bottom:200px; padding-bottom: 7.5% !important; width: 88% !important; height: 7.1rem !important; background: linear-gradient(203deg, #B9B970 17%, #019074);margin-left: 0px">
                <img class="icon-line"
                  style="color: white !important; filter: brightness(0) invert(1); width: 100px; height: 3.4rem; display: block; margin: 20px auto;"
                  src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_equipamentos.svg"
                  alt="Imagem de capa do card">
                <div class="card-footer mt-2 pb-4 pt-4">
                  <span class="card-text">EQUIPAMENTOS</span>
                  <!-- <button type="button" class="btn btn-secondary btd" @click="openDoc('empresarial')" data-doc="auto"
                    data-mdb-toggle="tooltip" title="Download">
                    <i class="fa-solid fa-download"></i>
                  </button> -->
                </div>
              </div>
            </div>

            <!-- Card 4 -->
            <div class="col-2">
              <div class="card mt-2 pt-2 pb-3"
                style="margin-bottom:200px; padding-bottom: 7.5% !important; width: 88% !important; height: 7.1rem !important; background: linear-gradient(203deg, #B9B970 17%, #019074);margin-left: -30px">
                <img class="icon-line"
                  style="color: white !important; filter: brightness(0) invert(1); width: 80px; height: 3.2rem; display: block; margin: 20px auto;"
                  src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/icon_viagem.svg"
                  alt="Imagem de capa do card">
                <div class="card-footer mt-2 pb-4 pt-4" style="margin-top: 13px !important">
                  <span class="card-text" style="padding-right: 14px; padding-left: 16px;">VIAGEM</span>
                  <!-- <button type="button" class="btn btn-secondary btd" @click="openDoc('viagem')" data-doc="auto"
                    data-mdb-toggle="tooltip" title="Download">
                    <i class="fa-solid fa-download"></i>
                  </button> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="carousel-item">
          <section>
            <div class="subtitle-container mt-4 ml-2">
              <h3 class="title" style="color: #19987C">CATÁLOGO DE API - GESTÃO CARTEIRA</h3>
            </div>
            <div class="linha-api"></div>
          </section>

          <div class="row mt-5 main-div" style="margin-left:22% !important">
            <!-- Card 1 -->
            <div class="col-2">
              <div class="card mt-2"
                style="margin-bottom:200px; padding-bottom: 7.5% !important; width: 87% !important; height: 7.3rem !important; background: linear-gradient(203deg, #B9B970 17%, #019074);margin-left: 20px">
                <img class="icon-line"
                  style="color: white !important; filter: brightness(0) invert(1); width: 100px; height: 63px; display: block; margin: 20px auto;"
                  src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_apolice.svg"
                  alt="Imagem de capa do card">
                <div class="card-footer mt-2 pb-4 pt-4">
                  <span style="padding-right: 14px; padding-left: 16px;">APÓLICE</span>
                  <!-- <button type="button" class="btn btn-secondary btd" @click="openDoc('apolice')" data-doc="auto"
                    data-mdb-toggle="tooltip" title="Download" style="margin-top: 10px;">
                    <i class="fa-solid fa-download"></i>
                  </button> -->
                </div>
                <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="prev"
                  style="margin-top:137px !important">
                  <i class="fas fa-angle-left"
                    style="color: #0B9274; font-size: 28px; margin-left:-370px; margin-top:40px"></i>
                </a>
              </div>
            </div>


            <!-- Card 2 -->
            <div class="col-2">
              <div class="card mt-2"
                style="margin-bottom:200px; padding-bottom: 7.5% !important; width: 87% !important; height: 7.3rem !important; background: linear-gradient(203deg, #B9B970 17%, #019074);margin-left: -10px">
                <img class="icon-line"
                  style="color: white !important; filter: brightness(0) invert(1); width: 100px; height: 63px; display: block; margin: 20px auto;"
                  src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_parcela.svg"
                  alt="Imagem de capa do card">
                <div class="card-footer mt-2 pb-4 pt-4">
                  <span>PARCELAS</span>
                  <!-- <button type="button" class="btn btn-secondary btd" @click="openDoc('parcelas')" data-doc="auto"
                    data-mdb-toggle="tooltip" title="Download">
                    <i class="fa-solid fa-download"></i>
                  </button> -->
                </div>
              </div>
            </div>

            <!-- Card 3 -->
            <div class="col-2">
              <div class="card mt-2"
                style="margin-bottom:200px; padding-bottom: 7.5% !important; width: 87% !important; height: 7.3rem !important; background: linear-gradient(203deg, #B9B970 17%, #019074);margin-left: -40px">
                <img class="icon-line"
                  style="color: white !important; filter: brightness(0) invert(1); width: 100px; height: 63px; display: block; margin: 20px auto;"
                  src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_apolice.svg"
                  alt="Imagem de capa do card">
                <div class="card-footer mt-2 pb-4 pt-4">
                  <span style="padding-right: 14px; padding-left: 16px;">INADIMPLENCIA</span>
                  <!-- <button type="button" class="btn btn-secondary btd" @click="openDoc('inadimplencia')" data-doc="auto"
                    data-mdb-toggle="tooltip" title="Download" style="margin-top: 10px;">
                    <i class="fa-solid fa-download"></i>
                  </button> -->
                </div>
              </div>
            </div>


            <!-- Card 4 -->
            <div class="col-2">
              <div class="card mt-2"
                style="margin-bottom:200px; padding-bottom: 7.5% !important; width: 87% !important; height: 7.3rem !important; background: linear-gradient(203deg, #B9B970 17%, #019074);margin-left: -70px">
                <img class="icon-line"
                  style="color: white !important; filter: brightness(0) invert(1); width: 100px; height: 63px; display: block; margin: 20px auto;"
                  src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_comissao.svg"
                  alt="Imagem de capa do card">
                <div class="card-footer mt-2 pb-4 pt-4">
                  <span style="padding-right: 14px; padding-left: 16px;">COMISSÃO</span>
                  <!-- <button type="button" class="btn btn-secondary btd" @click="openDoc('comissao')" data-doc="auto"
                    data-mdb-toggle="tooltip" title="Download">
                    <i class="fa-solid fa-download"></i>
                  </button> -->
                </div>
                <a href="#carouselExampleControls" role="button" data-slide="next"
                  style="color: #0B9274; font-size: 28px; margin-left:-5px; margin-top:-30px !important">
                  <i class="fas fa-angle-right"
                    style="color: #0B9274; font-size: 28px; margin-left:195px; margin-top:-120px !important"></i>
                </a>
              </div>
            </div>
          </div>

          <div class="row sub-div ml-5" style="margin-left:22% !important">
            <!-- Card 1 -->
            <div class="col-2">
              <div class="card mt-2"
                style="margin-bottom:200px; padding-bottom: 7.5% !important; width: 87% !important; height: 7.3rem !important; background: linear-gradient(203deg, #B9B970 17%, #019074);margin-left: 20px">
                <img class="icon-line"
                  style="color: white !important; filter: brightness(0) invert(1); width: 110px; height: 63px; display: block; margin: 20px auto;"
                  src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_renovacao.svg"
                  alt="Imagem de capa do card">
                <div class="card-footer mt-2 pb-4 pt-4">
                  <span class="card-text">RENOVAÇÃO</span>
                  <!-- <button type="button" class="btn btn-secondary btd" @click="openDoc('renovacao')" data-doc="auto"
                    data-mdb-toggle="tooltip" title="Download">
                    <i class="fa-solid fa-download"></i>
                  </button> -->
                </div>
              </div>
            </div>

            <!-- Card 3 -->
            <div class="col-2">
              <div class="card mt-2"
                style="margin-bottom:200px; padding-bottom: 4% !important; width: 87% !important; height: 7.3rem !important; background: linear-gradient(203deg, #B9B970 17%, #019074);margin-left: -10px">
                <img class="icon-line"
                  style="color: white !important; filter: brightness(0) invert(1); width: 100px; height: 63px; display: block; margin: 20px auto;"
                  src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_pendencia.svg"
                  alt="Imagem de capa do card">
                <div class="card-footer mt-2 pb-4 pt-4">
                  <span class="card-text" style="padding-right: 10px; padding-left: 2px;">PENDÊNCIA</span>
                  <!-- <button type="button" class="btn btn-secondary btd" @click="openDoc('pendencia')" data-doc="auto"
                    data-mdb-toggle="tooltip" title="Download">
                    <i class="fa-solid fa-download"></i>
                  </button> -->
                </div>
              </div>
            </div>

            <!-- Card 4 -->
            <div class="col-2">
              <div class="card mt-2"
                style="margin-bottom:200px; padding-bottom: 4% !important; width: 87% !important; height: 7.3rem !important; background: linear-gradient(203deg, #B9B970 17%, #019074);margin-left: -40px">
                <img class="icon-line"
                  style="color: white !important; filter: brightness(0) invert(1); width: 100px; height: 63px; display: block; margin: 20px auto;"
                  src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_recusa.svg"
                  alt="Imagem de capa do card">
                <div class="card-footer mt-2 pb-4 pt-4">
                  <span class="card-text" style="padding-right: 14px; padding-left: 16px;">RECUSA</span>
                  <!-- <button type="button" class="btn btn-secondary btd" @click="openDoc('recusa')" data-doc="auto"
                    data-mdb-toggle="tooltip" title="Download">
                    <i class="fa-solid fa-download"></i>
                  </button> -->
                </div>
              </div>
            </div>

            <!-- Card 4 -->
            <div class="col-2">
              <div class="card mt-2"
                style="margin-bottom:200px; padding-bottom: 4% !important; width: 87% !important; height: 7.3rem !important; background: linear-gradient(203deg, #B9B970 17%, #019074);margin-left: -70px">
                <img class="icon-line"
                  style="color: white !important; filter: brightness(0) invert(1); width: 100px; height: 63px; display: block; margin: 20px auto;"
                  src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_sinistro.svg"
                  alt="Imagem de capa do card">
                <div class="card-footer mt-2 pb-4 pt-4">
                  <span class="card-text" style="padding-right: 15px; padding-left: 10px;">SINISTRO</span>
                  <!-- <button type="button" class="btn btn-secondary btd" @click="openDoc('sinistro')" data-doc="auto"
                    data-mdb-toggle="tooltip" title="Download">
                    <i class="fa-solid fa-download"></i>
                  </button> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="carousel-item">
          <section>
            <div class="subtitle-container mt-4">
              <h3 class="title" style="color: #19987C">CATÁLOGO DE API - PÓS VENDAS</h3>
            </div>
            <div class="linha-api"></div>
          </section>

          <div class="row mt-5 main-div-api mb-1" style="margin-left: 24% !important">
            <!-- Card 1 -->
            <div class="col-2">
              <div class="card mt-2"
                style="margin-bottom:100px; padding-bottom: 7.5% !important; width: 111% !important; height: 7.1rem !important; background: linear-gradient(203deg, #B9B970 17%, #019074);">
                <img class="icon-line"
                  style="color: white !important; filter: brightness(0) invert(1); width: 100px; height: 70px; display: block; margin: 20px auto;"
                  src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_doc_apolice.svg"
                  alt="Imagem de capa do card">
                <div class="card-footer pb-4 pt-4">
                  <span style="padding-right: 13px; padding-left: 12px;">APÓLICE</span>
                  <!-- <button type="button" class="btn btn-secondary btd" @click="openDoc('apolice')" data-doc="auto"
                    data-mdb-toggle="tooltip" title="Download">
                    <i class="fa-solid fa-download"></i>
                  </button> -->
                </div>
                <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="prev"
                  style="margin-top:143px !important">
                  <i class="fas fa-angle-left"
                    style="color: #0B9274; font-size: 28px; margin-left:-362px; margin-top:-33px"></i>
                </a>
              </div>
            </div>

            <!-- Card 3 -->
            <div class="col-2">
              <div class="card mt-2"
                style="margin-bottom:200px; padding-bottom: 4% !important; width: 113% !important; height: 7.1rem !important; background: linear-gradient(203deg, #B9B970 17%, #019074);">
                <img class="icon-line"
                  style="color: white !important; filter: brightness(0) invert(1); width: 100px; height: 70px; display: block; margin: 20px auto;"
                  src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_doc_endosso.svg"
                  alt="Imagem de capa do card">
                <div class="card-footer pb-4 pt-4">
                  <span style="padding-right: 8px; padding-left: 4px;">ENDOSSO</span>
                  <!-- <button type="button" class="btn btn-secondary btd" @click="openDoc('impressao-endosso')"
                    data-doc="auto" data-mdb-toggle="tooltip" title="Download">
                    <i class="fa-solid fa-download"></i>
                  </button> -->
                </div>
              </div>
            </div>

            <!-- Card 4 -->
            <div class="col-2">
              <div class="card mt-2"
                style="margin-bottom:200px; padding-bottom: 4% !important; width: 113% !important; height: 7.1rem !important; background: linear-gradient(203deg, #B9B970 17%, #019074);">
                <img class="icon-line"
                  style="color: white !important; filter: brightness(0) invert(1); width: 100px; height: 70px; display: block; margin: 20px auto;"
                  src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_doc_segurado.svg"
                  alt="Imagem de capa do card">
                <div class="card-footer pb-4 pt-4">
                  <span style="padding-right: 8px; padding-left: 4px;">SEGURADO</span>
                  <!-- <button type="button" class="btn btn-secondary btd" @click="openDoc('impressao-segurado')"
                    data-doc="auto" data-mdb-toggle="tooltip" title="Download">
                    <i class="fa-solid fa-download"></i>
                  </button> -->
                </div>
              </div>
            </div>

            <!-- Card 4 -->
            <div class="col-2">
              <div class="card mt-2"
                style="margin-bottom:200px; padding-bottom: 4% !important; width: 113% !important; height: 7.1rem !important; background: linear-gradient(203deg, #B9B970 17%, #019074);">
                <img class="icon-line"
                  style="color: white !important; filter: brightness(0) invert(1); width: 100px; height: 70px; display: block; margin: 20px auto;"
                  src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_doc_boleto.svg"
                  alt="Imagem de capa do card">
                <div class="card-footer pb-4 pt-4">
                  <span style="padding-right: 12px; padding-left: 9px;">BOLETO</span>
                  <!-- <button type="button" class="btn btn-secondary btd" @click="openDoc('impressao-boleto')"
                    data-doc="auto" data-mdb-toggle="tooltip" title="Download">
                    <i class="fa-solid fa-download"></i>
                  </button> -->
                </div>
                <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next"
                  style="margin-top:130px !important">
                  <i class="fas fa-angle-right"
                    style="color: #0B9274; font-size: 28px;margin-left:95px !important; "></i>
                </a>
              </div>
            </div>
          </div>

          <div class="row sub-div mb-4">
          </div>

        </div>
      </div>
      <a style="color: transparent !important;background: transparent;" class="carousel-control-prev"
        href="#carouselExampleControls" role="button" data-slide="prev">
        <span style="color: transparent !important;background: transparent;" class="carousel-control-prev-icon"
          aria-hidden="true"></span>
        <span style="color: transparent !important;background: transparent;" class="sr-only">Anterior</span>
      </a>
      <a style="color: transparent !important;background: transparent;" class="carousel-control-next"
        href="#carouselExampleControls" role="button" data-slide="next">
        <span style="color: transparent !important;background: transparent;" class="carousel-control-next-icon"
          aria-hidden="true"></span>
        <span style="color: transparent !important;background: transparent;" class="sr-only">Próximo</span>
      </a>
    </div>


    <!-- O Modal Rest Soap -->
    <div v-if="showModal" class="modal fade bd-example-modal-lg" id="myModal" tabindex="-1"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" style="font-weight: 600;">Alertas / Notificações </h5>
            <button type="button" class="btn-close" data-mdb-dismiss="modal" @click="closeModal"
              aria-label="Close"></button>
          </div>

          <div class="modal-body">
            <div class="col-12 col-sm-12" style="margin-left:-10px">
              <div class="form-outline mb-1">
                <div class="textarea-container mt-2 mb-4">
                  <h5 class="green-label">{{ this.modalData.titulo }}</h5>
                </div>
              </div>

              <div class="form-outline mb-1">
                <div class="textarea-container mt-4 mb-3 m-1">
                  <p style="white-space: pre-wrap">{{ this.modalData.descricao }}</p>
                </div>
              </div>

            </div>
          </div>

          <div class="mt-4" role="group" aria-label="Basic example">
            <div class="row m-1">
              <div v-if="this.modalData.visto != 'N'" class="col-9">
              </div>
              <div v-if="this.modalData.visto === 'N'" class="col-6">
              </div>
              <div v-if="this.modalData.visto === 'N'" class="col-3">
                <button @click="salvarComoLido" type="button" id="gestao-carteira"
                  style="width: 100% !important;color:white !important" class="footer-button btn btn-primary active"
                  data-mdb-ripple-init>MARCAR COMO VISTO</button>
              </div>
              <div class="col-3">
                <button @click="closeModal" type="button" id="gestao-carteira"
                  style="width: 100% !important;color:#0F9476 !important" class="footer-button btn btn-secondary"
                  data-mdb-ripple-init>FECHAR</button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="loader">
      <div>
        <div class="spinner-border"></div>
      </div>
    </div>
  </div>
</template>

<!-- Incluindo o Bootstrap JS -->
<script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/js/bootstrap.bundle.min.js"></script>
<script src="https://code.jquery.com/jquery-3.3.1.slim.min.js"
  integrity="sha384-q8i/X+965DzO0rT7abK41JStQIAqVgRVzpbzo5smXKp4YfRvH+8abtTE1Pi6jizo" crossorigin="anonymous"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.14.3/umd/popper.min.js"
  integrity="sha384-ZMP7rVo3mIykV+2+9J3UJ46jBk0WLaUAdn689aCwoqbBJiSnjAK/l8WvCWPIPm49" crossorigin="anonymous"></script>
<script src="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/js/bootstrap.min.js"
  integrity="sha384-ChfqqxuZUCnJSK3+MXmPNIyE6ZbWh2IMqE241rYiqJxyMiZ6OW/JmZQ5stwEULTy" crossorigin="anonymous"></script>
<script>
import axios from 'axios';
import * as alertUtils from '@/utils/alert';
import * as loaderUtils from '@/utils/loader';
import FormNotch from './FormNotch.vue';

import $ from 'jquery'; // Importando jQuery
import 'mdb-ui-kit'; // Importando o JavaScript do MDB
import * as ajaxUtils from '@/utils/ajax';

export default {
  data() {
    return {
      selectedListaConcluidas: [],
      listaConcluidas: [],
      selectedListaEmAndamento: [],
      listaEmAndamento: [],
      selectedListaNotificacao: [],
      listaNotificacao: [
        {
          "id": "1",
          "titulo": "Atualização disponível",
          "descricao": "Uma nova versão do catálogo foi publicada.",
          "visto": "N"
        },
        {
          "id": "2",
          "titulo": "Serviço atualizado",
          "descricao": "O serviço de venda residencial sofreu alterações.",
          "visto": "S"
        },
        {
          "id": "3",
          "titulo": "Ação necessária",
          "descricao": "Revise os atributos pendentes de aprovação.",
          "visto": "N"
        },
        {
          "id": "4",
          "titulo": "Processamento concluído",
          "descricao": "A importação da planilha foi finalizada com sucesso.",
          "visto": "S"
        },
        {
          "id": "5",
          "titulo": "Erro detectado",
          "descricao": "Foram encontrados problemas no catálogo durante a validação.",
          "visto": "N"
        }
      ]
      ,
      campos: [],
      modalData: [],
      showModal: false,
      iconMap: [],
      situacaoMap: [],

    };
  },
  components: {
    FormNotch
  },
  methods: {
    async acessarDocumentacao(api){
      alertUtils.alertAtencao('Para consultar a documentação da ' +  api + ', acesse o menu Catálogo de API.');
    },
    async openDoc(nome){
      window.open('/massificados/corporativo/gerenciador-parceiros-ui/portal-api/downloads/' + nome + '.doc');
    },
    async buscarConcluidas() {
      this.listaConcluidas = await ajaxUtils.get(`/massificados/corporativo/gerenciador-parceiros/integracao/concluida`, false);
    },
    async buscarEmAndamento() {
      this.listaEmAndamento = await ajaxUtils.get(`/massificados/corporativo/gerenciador-parceiros/integracao/listar-integracoes-andamento`, false);
    },
    async buscarNotificacoes() {
      this.listaNotificacao = await ajaxUtils.get(`/massificados/corporativo/gerenciador-parceiros/notificacao-api/listar`, false);
      if (this.listaNotificacao != null) {
        // this.listaNotificacao = [
        //   {
        //     "id": "1",
        //     "titulo": "Atualização disponível",
        //     "descricao": "Uma nova versão do catálogo foi publicada.",
        //     "visto": "N"
        //   },
        //   {
        //     "id": "2",
        //     "titulo": "Serviço atualizado",
        //     "descricao": "O serviço de venda residencial sofreu alterações.",
        //     "visto": "S"
        //   },
        //   {
        //     "id": "3",
        //     "titulo": "Ação necessária",
        //     "descricao": "Revise os atributos pendentes de aprovação.",
        //     "visto": "N"
        //   },
        //   {
        //     "id": "4",
        //     "titulo": "Processamento concluído",
        //     "descricao": "A importação da planilha foi finalizada com sucesso.",
        //     "visto": "S"
        //   },
        //   {
        //     "id": "5",
        //     "titulo": "Erro detectado",
        //     "descricao": "Foram encontrados problemas no catálogo durante a validação.",
        //     "visto": "N"
        //   }
        // ];

        this.listaNotificacao = this.listaNotificacao.reverse();
      }
    },
    async salvarComoLido() {
      this.closeModal();

      const salvarLido = await ajaxUtils.get(`/massificados/corporativo/gerenciador-parceiros/notificacao-api/visualizar/${this.modalData.id}`, false, 'Salvo como visto!');

      this.buscarNotificacoes();
    },
    async openModal(data) {
      this.showModal = true;
      this.modalData = data;

      try {
        setTimeout(async () => {
          const modalElement = document.querySelector('.modal');
          const modalInstance = await new mdb.Modal(modalElement);

          await modalInstance.show();
        }, 200); // 200 milissegundos = 0.2 segundos
      } catch (error) {
        console.log(error)
      }
    },
    async closeModal() {
      this.showModal = false;

      $('.modal').hide();
      $('.modal-backdrop').hide();
      $('body').css('overflow', 'auto'); // Ativa a barra de rolagem
      $('body').css('padding-right', '0px');
    },
    formatarData(data) {
      const date = new Date(data);
      return date.toLocaleDateString('pt-BR');
    },
    async carregandoCards(loader) {

      // this.listaEmAndamento = [
      //   { id: 1, codigo: '001', codigoOperadora: 23, codigoProduto: 'PROD001', api: 'AUTOMÓVEL',      dataCriacao: '2025-06-24', situacao: 'APROVACAO-PRODUTOS' },
      //   { id: 2, codigo: '002', codigoOperadora: 24, codigoProduto: 'PROD002', api: 'RESIDENCIAL',    dataCriacao: '2025-06-24', situacao: 'DESENVOLVIMENTO' },
      //   { id: 3, codigo: '003', codigoOperadora: 25, codigoProduto: 'PROD003', api: 'IMOBILIÁRIO',    dataCriacao: '2025-06-24', situacao: 'HOMOLOGACAO-TI' },
      //   { id: 4, codigo: '004', codigoOperadora: 26, codigoProduto: 'PROD004', api: 'CONDOMÍNIO',     dataCriacao: '2025-06-24', situacao: 'APROVACAO-NEGOCIO' },
      //   { id: 5, codigo: '005', codigoOperadora: 27, codigoProduto: 'PROD005', api: 'VIDA',           dataCriacao: '2025-06-24', situacao: 'EM TESTES' },
      //   { id: 6, codigo: '006', codigoOperadora: 28, codigoProduto: 'PROD006', api: 'ALUGUEL',        dataCriacao: '2025-06-24', situacao: 'AGUARDANDO-INTEG' },
      //   { id: 7, codigo: '007', codigoOperadora: 29, codigoProduto: 'PROD007', api: 'GARANTIA',       dataCriacao: '2025-06-24', situacao: 'HOMOLOGACAO-USUARIO' },
      //   { id: 8, codigo: '008', codigoOperadora: 30, codigoProduto: 'PROD008', api: 'EMPRESARIAL',    dataCriacao: '2025-06-24', situacao: 'PLANEJAMENTO' },
      //   { id: 9, codigo: '009', codigoOperadora: 31, codigoProduto: 'PROD009', api: 'AGRO SAFRA',     dataCriacao: '2025-06-24', situacao: 'DESENVOLVIMENTO' },
      //   { id: 10, codigo: '010', codigoOperadora: 32, codigoProduto: 'PROD010', api: 'EQUIPAMENTOS',  dataCriacao: '2025-06-24', situacao: 'APROVACAO-PRODUTOS' },
      //   { id: 11, codigo: '011', codigoOperadora: 33, codigoProduto: 'PROD011', api: 'VIAGEM',        dataCriacao: '2025-06-24', situacao: 'ANALISE' },
      //   { id: 12, codigo: '012', codigoOperadora: 34, codigoProduto: 'PROD012', api: 'APÓLICE',       dataCriacao: '2025-06-24', situacao: 'EMITIDO' },
      //   { id: 13, codigo: '013', codigoOperadora: 35, codigoProduto: 'PROD013', api: 'PARCELAS PAGAS',dataCriacao: '2025-06-24', situacao: 'CONFERENCIA' },
      //   { id: 14, codigo: '014', codigoOperadora: 36, codigoProduto: 'PROD014', api: 'INADIMPLÊNCIA', dataCriacao: '2025-06-24', situacao: 'NEGOCIACAO' },
      //   { id: 15, codigo: '015', codigoOperadora: 37, codigoProduto: 'PROD015', api: 'COMISSÃO',      dataCriacao: '2025-06-24', situacao: 'PAGAMENTO' },
      //   { id: 16, codigo: '016', codigoOperadora: 38, codigoProduto: 'PROD016', api: 'RENOVAÇÃO',     dataCriacao: '2025-06-24', situacao: 'AGUARDANDO' },
      //   { id: 17, codigo: '017', codigoOperadora: 39, codigoProduto: 'PROD017', api: 'PENDÊNCIA',     dataCriacao: '2025-06-24', situacao: 'PENDENTE' },
      //   { id: 18, codigo: '018', codigoOperadora: 40, codigoProduto: 'PROD018', api: 'RECUSA',        dataCriacao: '2025-06-24', situacao: 'RECUSADO' },
      //   { id: 19, codigo: '019', codigoOperadora: 41, codigoProduto: 'PROD019', api: 'SINISTRO',      dataCriacao: '2025-06-24', situacao: 'ABERTO' },
      //   { id: 20, codigo: '020', codigoOperadora: 42, codigoProduto: 'PROD020', api: 'ENDOSSO',       dataCriacao: '2025-06-24', situacao: 'PROCESSANDO' },
      //   { id: 21, codigo: '021', codigoOperadora: 43, codigoProduto: 'PROD021', api: 'CARTÃO SEGURADO',dataCriacao: '2025-06-24', situacao: 'VALIDANDO' },
      //   { id: 22, codigo: '022', codigoOperadora: 44, codigoProduto: 'PROD022', api: 'BOLETO',        dataCriacao: '2025-06-24', situacao: 'GERADO' }
      // ];

      // this.listaConcluidas = [
      //   { codigo: '001', codigoProduto: 'PROD001', api: 'AUTOMÓVEL',       qtd_corretor: 12, produto: 'Seguro Automóvel' },
      //   { codigo: '002', codigoProduto: 'PROD002', api: 'RESIDENCIAL',     qtd_corretor: 8,  produto: 'Seguro Residencial' },
      //   { codigo: '003', codigoProduto: 'PROD003', api: 'IMOBILIÁRIO',     qtd_corretor: 5,  produto: 'Seguro Imobiliário' },
      //   { codigo: '004', codigoProduto: 'PROD004', api: 'CONDOMÍNIO',      qtd_corretor: 6,  produto: 'Seguro Condomínio' },
      //   { codigo: '005', codigoProduto: 'PROD005', api: 'VIDA',            qtd_corretor: 20, produto: 'Seguro de Vida' },
      //   { codigo: '006', codigoProduto: 'PROD006', api: 'ALUGUEL',         qtd_corretor: 4,  produto: 'Seguro Aluguel' },
      //   { codigo: '007', codigoProduto: 'PROD007', api: 'GARANTIA',        qtd_corretor: 10, produto: 'Seguro Garantia' },
      //   { codigo: '008', codigoProduto: 'PROD008', api: 'EMPRESARIAL',     qtd_corretor: 7,  produto: 'Seguro Empresarial' },
      //   { codigo: '009', codigoProduto: 'PROD009', api: 'AGRO SAFRA',      qtd_corretor: 15, produto: 'Seguro Agro Safra' },
      //   { codigo: '010', codigoProduto: 'PROD010', api: 'EQUIPAMENTOS',    qtd_corretor: 9,  produto: 'Seguro Equipamentos' },
      //   { codigo: '011', codigoProduto: 'PROD011', api: 'VIAGEM',          qtd_corretor: 11, produto: 'Seguro Viagem' },
      //   { codigo: '012', codigoProduto: 'PROD012', api: 'APÓLICE',         qtd_corretor: 18, produto: 'Gestão de Apólices' },
      //   { codigo: '013', codigoProduto: 'PROD013', api: 'PARCELAS PAGAS',  qtd_corretor: 6,  produto: 'Controle de Parcelas' },
      //   { codigo: '014', codigoProduto: 'PROD014', api: 'INADIMPLÊNCIA',   qtd_corretor: 3,  produto: 'Gestão de Inadimplência' },
      //   { codigo: '015', codigoProduto: 'PROD015', api: 'COMISSÃO',        qtd_corretor: 9,  produto: 'Gestão de Comissão' },
      //   { codigo: '016', codigoProduto: 'PROD016', api: 'RENOVAÇÃO',       qtd_corretor: 14, produto: 'Gestão de Renovações' },
      //   { codigo: '017', codigoProduto: 'PROD017', api: 'PENDÊNCIA',       qtd_corretor: 2,  produto: 'Gestão de Pendências' },
      //   { codigo: '018', codigoProduto: 'PROD018', api: 'RECUSA',          qtd_corretor: 1,  produto: 'Gestão de Recusas' },
      //   { codigo: '019', codigoProduto: 'PROD019', api: 'SINISTRO',        qtd_corretor: 16, produto: 'Gestão de Sinistros' },
      //   { codigo: '020', codigoProduto: 'PROD020', api: 'ENDOSSO',         qtd_corretor: 7,  produto: 'Gestão de Endossos' },
      //   { codigo: '021', codigoProduto: 'PROD021', api: 'CARTÃO SEGURADO', qtd_corretor: 5,  produto: 'Gestão de Cartão Segurado' },
      //   { codigo: '022', codigoProduto: 'PROD022', api: 'BOLETO',          qtd_corretor: 13, produto: 'Gestão de Boletos' }
      // ];

      
      this.iconMap = [
        { key:'AUTOMÓVEL',     img:'icon_carro.svg',        label:'AUTOMÓVEL',     codes:[7],                   includes:['AUTOMÓVEL'],                      style:'', customClass:'' },
        { key:'RESIDENCIAL',   img:'icon_residencial.svg',  label:'RESIDENCIAL',   codes:[14],                  includes:['RESIDENCIAL'],                   style:'', customClass:'' },
        { key:'IMOBILIÁRIO',   img:'icon_imobiliario.svg',  label:'IMOBILIÁRIO',   codes:[43,44],               includes:['IMOBILIARIO','IMOBILIÁRIO'],     style:'', customClass:'card-img--mt5' },
        { key:'CONDOMÍNIO',    img:'icon_condominio.svg',   label:'CONDOMÍNIO',    codes:[12],                  includes:['CONDOMÍNIO','CONDOMINIO'],       style:'', customClass:'' },
        { key:'VIDA',          img:'ic_vida.svg',           label:'VIDA',          codes:[47],                  includes:['VIDA'],                          style:'', customClass:'card-img--mt5' , path:'portal-api' },
        { key:'ALUGUEL',       img:'icon_aluguel.svg',      label:'ALUGUEL',       codes:[55,56,72,73],         includes:['ALUGUEL'],                       style:'', customClass:'card-img--mt5' },
        { key:'GARANTIA',      img:'icon_garantia.svg',     label:'GARANTIA',      codes:[7503,7602,7603],      includes:['GARANTIA'],                      style:'', customClass:'mt-5' },
        { key:'EMPRESARIAL',   img:'icon_empresarial.svg',  label:'EMPRESARIAL',   codes:[62,63],               includes:['EMPRESARIAL'],                   style:'', customClass:'mt-53' },
        { key:'AGRO SAFRA',    img:'icon_agro.svg',         label:'AGRO',          codes:[103],                 includes:['AGRO SAFRA','AGROSAFRA'],        style:'', customClass:'card-img--mt5' },
        { key:'EQUIPAMENTOS',  img:'icon_equipamentos.svg', label:'EQUIPAMENTOS',  codes:[10005,10006,10017],   includes:['EQUIPAMENTOS'],                  style:'', customClass:'' },
        { key:'VIAGEM',        img:'icon_viagem.svg',       label:'VIAGEM',        codes:[108],                 includes:['VIAGEM'],                        style:'', customClass:'card-img--mt5' },
        { key:'APÓLICE',       img:'ic_apolice.svg',        label:'APÓLICE',                                      includes:['APÓLICE','APOLICE'],            style:'', customClass:'card-img--mt5', path:'portal-api' },
        { key:'PARCELAS PAGAS',img:'ic_apolice.svg',        label:'PARCELAS PAGAS',                               includes:['PARCELAS PAGAS'],               style:'', customClass:'card-img--mt5' },
        { key:'INADIMPLÊNCIA', img:'ic_apolice.svg',        label:'INADIMPLÊNCIA',                                includes:['INADIMPLÊNCIA','INADIMPLENCIA'],style:'', customClass:'' },
        { key:'COMISSÃO',      img:'ic_apolice.svg',        label:'COMISSÃO',                                     includes:['COMISSÃO','COMISSAO'],          style:'', customClass:'card-img--mt5' },
        { key:'RENOVAÇÃO',     img:'ic_apolice.svg',        label:'RENOVAÇÃO',                                    includes:['RENOVAÇÃO','RENOVACAO'],        style:'', customClass:'' },
        { key:'PENDÊNCIA',     img:'ic_apolice.svg',        label:'PENDÊNCIA',                                    includes:['PENDÊNCIA','PENDENCIA'],        style:'', customClass:'card-img--mt5' },
        { key:'RECUSA',        img:'ic_apolice.svg',        label:'RECUSA',                                       includes:['RECUSA'],                       style:'', customClass:'card-img--mt5' },
        { key:'SINISTRO',      img:'ic_apolice.svg',        label:'SINISTRO',                                     includes:['SINISTRO'],                     style:'', customClass:'card-img--mt5' },
        { key:'ENDOSSO',       img:'ic_apolice.svg',        label:'ENDOSSO',                                      includes:['ENDOSSO'],                      style:'', customClass:'card-img--mt5' },
        { key:'CARTÃO SEGURADO', img:'ic_apolice.svg',      label:'CARTÃO SEGURADO',                              includes:['CARTÃO SEGURADO','CARTAO SEGURADO'], style:'', customClass:'card-img--mt5' },
        { key:'BOLETO',        img:'ic_doc_boleto.svg',     label:'BOLETO',                                       includes:['BOLETO'],                       style:'', customClass:'grayscale', path:'portal-api' },
      ];

      this.situacaoMap = [
        {
          key: 'APROVACAO-PRODUTOS',
          label: 'APROVAÇÃO',
          style: 'margin-top: 10% !important; margin-left: -45px;width:140% !important'
        },
        {
          key: 'CONFIGURACAO-ACEITE',
          label: 'CONFIGURAÇÃO ACEITE',
          style: 'margin-top: 10% !important; margin-left: -45px;width:150% !important'
        },
        {
          key: 'DESENVOLVINENTO',
          label: 'DESENVOLVINENTO',
          style: 'margin-top: 10% !important; margin-left: -45px;width:150% !important'
        },
        {
          key: 'HOMOLOGACAO-TI',
          label: 'HOMOLOGAÇÃO',
          style: 'margin-top: 10% !important; margin-left: -45px;width:150% !important'
        },
        {
          key: 'HOMOLOGACAO-PRODUTOS',
          label: 'HOMOLOGAÇÃO',
          style: 'margin-top: 10% !important; margin-left: -45px;width:150% !important'
        },
        {
          key: 'CONFIGURACAO-PRODUCAO',
          label: 'CONFIG. PRODUÇÃO',
          style: 'margin-top: 10% !important; margin-left: -45px;width:150% !important'
        }
      ]

      if(loader){
        $('.father-div').css('display','none');
        $('.father-div-progress').css('display','none');
        $('.father-div-alert').css('display','none');

        $('.card-completed-title')[0].setAttribute('style', 'margin-top: -57% !important');

        $('.card-progress-title')[0].setAttribute('style', 'margin-top: 4% !important');

        $('.alert-title')[0].setAttribute('style', 'margin-top: -47% !important');
      } else {
        $('.father-div').css('display','block');
        $('.father-div-progress').css('display','block');
        $('.father-div-alert').css('display','block');

        $('.card-completed-title')[0].setAttribute('style', 'margin-top: 3% !important');

        $('.card-progress-title')[0].setAttribute('style', 'margin-top: 62% !important');

        $('.alert-title')[0].setAttribute('style', 'margin-top: -1% !important');
      }
    },
    iconFor(item) {
      if (!item) return null; 
    
      const code = Number(item.codigoProduto);
      const prodName = this._normalize(item.produto);
      

      let found = this.iconMap.find(m => Array.isArray(m.codes) && m.codes.includes(code));
      if (found) return found;


      found = this.iconMap.find(m =>
        Array.isArray(m.includes) &&
        m.includes.some(inc => prodName.includes(this._normalize(inc)))
      );
      if (found) return found;


      found = this.iconMap.find(m => prodName.includes(this._normalize(m.key)));
      if (found) return found;


      return null;
    },
    safeIcon(item) {
      const ic = this.iconFor(item);
      // garante um objeto mesmo quando iconFor retornar null
      return ic || { img: '', label: '', style: '', path: 'consulta' };
    },

    _normalize(str) {
      return String(str || '')
        .toUpperCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
    },
  iconsForApi(item) {
    if (!item || !item.api) return [];
    const api = this._normalize(item.api);

    return this.iconMap.filter(ic => api.includes(this._normalize(ic.key)));
  }

  },

  async mounted() {
    
    loaderUtils.addLoarder();

    this.carregandoCards(true);

    // Aguarda as 3 funções concluírem
    await Promise.all([
        this.buscarConcluidas(),
        this.buscarEmAndamento(),
        this.buscarNotificacoes()
    ]);

    loaderUtils.removeLoader();

    this.carregandoCards(false);
  }
}
</script>

<style scoped>
.cards {
  margin-top: -1.6% !important
}

.title-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 5vh;
  margin-top: 4%;
  margin-bottom: -0.5%;
}

.subtitle-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 5vh;
  margin-top: 1%;
  margin-bottom: 1.5%;
  margin-right: 2%;
}

nav {
  margin-top: -2%;
  background-color: transparent !important;
  padding: 0px 0px 0px 0px;
  width: 16%;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, 0) !important;
  margin-left: 41%;
}

.btn-acoes {
  margin-top: -13px !important;
}

.dt-search {
  display: none !important;
}

.dt-input {
  width: 9rem !important;
  height: 15px !important;
}

div.dt-paging nav {
  height: 36px !important;
  width: -webkit-fill-available !important;
}

nav,
nav .nav-wrapper i,
nav a.sidenav-trigger,
nav a.sidenav-trigger i {
  line-height: 21px !important;
}

.custom-modal .modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
}

.modal-backdrop {
  background-color: rgba(0, 0, 0, 0.5) !important;
}

.modal-content {
  background-color: #fff;
  /* Cor de fundo do modal */
  padding: 20px;
  border-radius: 8px;
}

.modal {
  display: block;
  max-height: 100rem !important;
  background: transparent !important;
}

.btn-danger {
  background: linear-gradient(254deg, #23c5ae 0%, #19a38f 100%) !important;
}

.dt-paging-button.current {
  background: #2FC8B2 !important;
  color: white !important;
}

input.form-control {
  padding-left: 10px !important;
  box-sizing: border-box !important;
  /* Ajusta o box model para incluir padding e borda */
  border: 1px solid #ccc !important;
  /* Borda */
  width: 100% !important;
  /* Largura total, evita vazamento */
}

/* Para navegadores baseados em Webkit (Chrome, Safari, Edge, etc.) */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  /* Remove as setas */
  margin: 0;
}

/* Para Firefox */
input[type="number"] {
  -moz-appearance: textfield;
  /* Remove as setas no Firefox */
}

.search-span {
  padding: 15px 10px 20px;
}

.fa-search.me-1 {
  padding-top: 2px;
}

.search-button {
  padding-bottom: 2.6rem !important;
  width: 11rem !important;
}

.card-title {
  font-size: 18px !important;
  color: #0B9274 !important;
  /* Cor do texto */
  text-align: center;
  /* Centraliza o texto */
  margin-top: -17%;
}

.card-progress-title {
  font-size: 18px !important;
  color: #0B9274 !important;
  /* Cor do texto */
  text-align: center;
  /* Centraliza o texto */
  margin-top: 3%;
  padding-top: 0% !important;
  margin-top: 66% !important;
}

.card-completed-title {
  font-size: 18px !important;
  color: #0B9274 !important;
  /* Cor do texto */
  text-align: center;
  /* Centraliza o texto */
  margin-top: 3%;
  padding-top: 60% !important;
  margin-top: 1% !important;
}

.card {
  margin-bottom: 20px;
  /* Menos espaçamento entre os cards */
  padding-bottom: 18% !important;
  border-radius: 4% !important;
  width: 30% !important;
  margin-top: 0% !important;
  border: none;
  box-shadow: 0px 0px 30px rgb(0 0 0 / 6%);
}

.linha {
  width: 46%;
  /* Largura total da linha */
  height: 2px;
  /* Linha fina (espessura de 2px) */
  background: linear-gradient(to right, #B9B970 40%, #1C9674 60%);
  margin: 10px auto;
  /* Centraliza a linha com espaçamento de 10px para cima e para baixo */
  margin-left: 29%
}

.linha-api {
  width: 10%;
  /* Largura total da linha */
  height: 2px;
  /* Linha fina (espessura de 2px) */
  background: linear-gradient(to right, #B9B970 40%, #1C9674 60%);
  margin: 0px auto;
  /* Centraliza a linha com espaçamento de 10px para cima e para baixo */
  margin-left: 45%;
  margin-top: -0.8%;
}

/* .banner {
  width: 100%;
  height: 141px;
  color: white;
  padding-top: 0.58rem;
  position: relative;
  background: url("../../../public/portal-api/img/banner.png") center center no-repeat;
} */

.banner {
  width: 100%;
  height: 141px;
  color: white;
  padding-top: 0.58rem;
  position: relative;
  background: url("../../../public/radar/img/banner-2.jpg") center center no-repeat;
}

.icon-line {
  font-size: 1px !important;
  width: 31%;
  color: white !important;
  margin: 0px auto 25px;
  /* Centraliza a linha com espaçamento de 10px para cima e para baixo */
  /* margin-top: 10% */
}

.card-footer {
  text-align: center;
  padding-top: 14px !important;
  background-color: white !important;
  color: #117F63 !important;
  padding-bottom: 11% !important;
  font-size: 12px;
  text-align: center !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
}

.main-div {
  margin-left: 9% !important;
  width: 91%;
  margin-bottom: -11% !important;
  max-height: 40% !important;
}

.main-div-api {
  margin-left: 7% !important;
  width: 71%;
  margin-bottom: -11% !important;
  max-height: 40% !important;
}

.sub-div {
  margin-left: 3% !important;
  width: 91%;
  margin-top: 3% !important;
}

.body-alert {
  display: flex;
  flex-direction: column;
  height: 230%;
  /* Ocupa toda a altura disponível do card */
  padding: 15px;
  margin-top: 57%;
}

.linha {
  border-top: 1px solid #ccc;
  /* Linha cinza */
  margin-bottom: 15px;
  /* Espaçamento entre a linha e a lista */
}

.alert-list {
  flex-grow: 2;
  /* Aumenta o espaço ocupado pela lista de alertas */
  overflow-y: auto;
  /* Habilita a rolagem quando os itens ultrapassarem a altura */
  max-height: 100%;
  /* Garante que a lista não ultrapasse a altura do card */
}

.alert-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  /* Alinha o conteúdo à esquerda */
  margin-bottom: 10px;
  /* Espaçamento entre os itens */
  padding-bottom: 10px;
  /* Espaço antes da linha */
  border-bottom: 1px solid #ccc;
  /* Linha cinza abaixo de cada item */
}

.alert-item a {
  text-decoration: none;
  color: inherit;
}

.warning-icon {
  color: #ffc107;
  /* Cor do ícone de alerta (amarelo) */
  margin-right: 5px;
  /* Espaçamento entre o ícone e o texto */
}

.alert-text strong {
  font-weight: bold;
  /* Alerta em negrito */
}

.warning-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  /* Tamanho do círculo */
  height: 18px;
  /* Tamanho do círculo */
  border-radius: 50%;
  /* Faz o ícone ficar em formato circular */
  /* background: linear-gradient(to right, #1C9674 0%, #1C9674 50%, #B9B970 100%); */
  /* Gradiente suave entre o verde e o amarelo */
  background: linear-gradient(52deg, #1C9674 0%, #B9B970 100%);
  color: white;
  /* Cor do ícone (branca para contrastar com o fundo) */
  font-size: 12px;
  /* Tamanho do ícone */
  padding: 5px;
  /* Ajuste do espaçamento interno, se necessário */
}


.alert-text {
  padding-left: 35px;
  font-size: 12px;
  text-align: left;
  /* Alinha o texto à esquerda dentro de seu espaço */
}

.text-center {
  text-align: center;
}

.green-label {
  color: #0B9274;
  /* Cor do rótulo */
  font-weight: 700;
  background: white;
  /* Fundo branco para sobrepor a linha do textarea */
  margin-left: 3px;
  /* Ajusta a posição horizontal conforme necessário */
}

.card-subtext {
  padding-left: 2px;
  font-weight: normal;
  font-size: 11px
}

.card-img {
  width: 30px !important;
  /* margin-left: 24% !important; */
  /* margin-top: 84%; */
}

.card-body {
  text-align: center;
  padding: 1rem 1rem 2rem 1rem;
}

.card-img-text {
  font-size: 13px;
  color: gray !important;
  font-style: normal;
}

.card-img-text-life {
  font-size: 13px;
  color: gray !important;
  font-style: normal;
  padding-left: 2px !important
}

.card-img-text-safra {
  font-size: 13px;
  color: gray !important;
  font-style: normal;
  width: 180%;
  margin-left: -5px;
}

.card-intern {
  /* height: 10px !important; */
  /* margin-left: 0% !important; */
  margin-bottom: 1rem !important;
  display: flex;
  justify-content: flex-start;
  border: 1px solid #ccc;
  border-radius: .8rem;
}

.father-div {
  margin-top: 0% !important;
  overflow-y: auto !important;
  max-height: 70% !important;
  height: 235px !important;
  width: 100% !important;
  overflow-x: hidden !important
}

.father-div-progress {
  overflow-y: auto !important;
  max-height: 70% !important;
  height: 235px !important;
  width: 100% !important;
  overflow-x: hidden !important;
  padding: 0 .5rem 0 0;
}

.card-icons {
  width: 140px !important;
  background-color: #F6F6F6 !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  border-top-left-radius: 14% !important;
  border-bottom-left-radius: 14% !important;
  border-right: 1px solid #ccc;
  padding: .6rem;
}

.card-info {
  background: transparent;
  padding-top: .7rem;
  width: 75%;
}

.card-content {
  height: 350px !important;
  width: 350px !important;
}

div.row.g-1 {
  /* margin-left: 34px !important; */
}

.carousel-item.active {
  width: 78% !important;
  max-width: 82% !important;
  margin-left: 13%;
}

.carousel-item {
  width: 78% !important;
  max-width: 82% !important;
  margin-left: 13%;
}

.title {
  font-size: 27px !important;
}

.title span {
  font-size: 15px !important;
}

.card-text {
  font-size: .75rem;
}

.card-footer {
  border-bottom-left-radius: 10px !important;
  border-bottom-right-radius: 10px !important;
}

.btd {
  margin-top: 10px !important;
  margin-bottom: -10px !important;
}

.card-img--mt5 {
  /* margin-top: 53px !important; */
}

.msg-integracoes {
  border: 1px solid #ccc;
  border-radius: .8rem;
  margin-left: .6rem;
  padding: .5rem
}

@import '/massificados/corporativo/gerenciador-parceiros-ui/portal-sistemas/css/style.css';
</style>
